import { canSaveSearch } from '@seek/seek-refine-job-search';
import { UPDATE_CRITERIA } from 'store/search/search';
import createApiClient from 'seek-jobs-api-client';
const api = createApiClient();

const SAVE_SEARCH_BEGIN = 'SAVE_SEARCH_BEGIN';
export const SAVE_SEARCH_SUCCESS = 'SAVE_SEARCH_SUCCESS';
const SAVE_SEARCH_ERROR = 'SAVE_SEARCH_ERROR';
const SAVE_SEARCH_EXCEEDED = 'SAVE_SEARCH_EXCEEDED';

const JOB_MAIL_BEGIN = 'JOB_MAIL_BEGIN';
export const JOB_MAIL_SUCCESS = 'JOB_MAIL_SUCCESS';
const JOB_MAIL_ERROR = 'JOB_MAIL_ERROR';
const JOBMAIL_EMAIL_CHANGE = 'JOBMAIL_EMAIL_CHANGE';

export const states = {
  SAVING: 'SAVING',
  SAVED: 'SAVED',
  UNSAVED: 'UNSAVED',
  ERROR: 'ERROR',
  EXCEEDED: 'EXCEEDED'
};

const initialState = {
  status: states.UNSAVED,
  errorMessage: '',
  saveable: true,
  title: ''
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case UPDATE_CRITERIA: {
      const { lastQuery, query } = action.payload;
      const { status } = state;

      const hasSavedSearch = status === states.SAVED;
      const saveable = canSaveSearch(lastQuery, query, hasSavedSearch);

      return {
        ...state,
        status: (saveable ? states.UNSAVED : status),
        saveable,
        errorMessage: '',
        title: ''
      };
    }

    case SAVE_SEARCH_BEGIN: {
      return {
        ...state,
        status: states.SAVING
      };
    }

    case SAVE_SEARCH_SUCCESS: {
      const { title } = action.payload;

      return {
        ...state,
        title,
        status: states.SAVED
      };
    }

    case SAVE_SEARCH_ERROR: {
      return {
        ...state,
        status: states.ERROR
      };
    }

    case SAVE_SEARCH_EXCEEDED: {
      return {
        ...state,
        status: states.EXCEEDED
      };
    }

    case JOBMAIL_EMAIL_CHANGE: {
      return {
        ...state,
        status: states.UNSAVED
      };
    }

    case JOB_MAIL_BEGIN: {
      return {
        ...state,
        status: states.SAVING
      };
    }

    case JOB_MAIL_SUCCESS: {
      return {
        ...state,
        status: states.SAVED
      };
    }

    case JOB_MAIL_ERROR: {
      return {
        ...state,
        status: states.ERROR,
        errorMessage: 'Something went wrong'
      };
    }

    default: {
      return state;
    }
  }
}

export const save = ({ query, location }) => dispatch => {
  dispatch({
    type: SAVE_SEARCH_BEGIN,
    meta: { hotjar: 'Saved Search' }
  });

  return api.candidate.saveSearch({ query, location })
    .then(({ title }) => {
      dispatch({
        type: SAVE_SEARCH_SUCCESS,
        payload: {
          title
        }
      });
    })
    .catch(err => {
      if (err.status === 422) {
        dispatch({ type: SAVE_SEARCH_EXCEEDED });
      } else {
        dispatch({ type: SAVE_SEARCH_ERROR, error: true, payload: err });
      }
    });
};

export const emailChange = () => ({ type: JOBMAIL_EMAIL_CHANGE });

export const jobMail = ({ query, location, emailAddress }) => dispatch => {
  dispatch({ type: JOB_MAIL_BEGIN });

  return api.candidate.jobMail({ query, location, emailAddress })
    .then(() => {
      dispatch({ type: JOB_MAIL_SUCCESS, meta: { hotjar: 'Job Mail Created' } });
    })
    .catch(err => {
      dispatch({ type: JOB_MAIL_ERROR, error: true, payload: err, meta: { hotjar: 'Job Mail Error' } });
    });
};



/** WEBPACK FOOTER **
 ** ./app/store/saveSearch/saveSearch.js
 **/